export default "__VITE_ASSET__CVkOZvWH__"